<template>
  <div>
    <form @submit.prevent="onSubmitStatus">
      <div style="max-width: 100%">
        <va-input v-model="disapprove_reason" label="Причина отмены" />
      </div>
      <div class="mt-4 text-center">
        <va-button type="button" color="primary" @click.stop="$emit('hide')">
          Закрыть
        </va-button>
        <va-button
          type="submit"
          :disabled="disapprove_reason.length === 0"
          color="info"
        >
          Сохранить
        </va-button>
      </div>
    </form>
  </div>
</template>

<script>
import api from '@/api/axios';
export default {
  props: {
    orderInfo: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      disapprove_reason: '',
    };
  },
  methods: {
    async onSubmitStatus() {
      try {
        await api.post(
          `/admin/order-reject-requests/${this.orderInfo.id}/decline`,
          {
            decline_note: this.disapprove_reason,
          }
        );
        this.$emit('hide', false);
        this.$emit('updateList');
      } catch (error) {
        this.$emit('hide', false);
        return error;
      }
    },
  },
};
</script>
